import React from 'react';
import AnimateHeight from 'react-animate-height';

import { WizardHeader } from './WizardItemHeader';
import { type WizardItemStatus } from './wizardModels';

export type WizardItemProps = {
  title: string;
  index: number;
  content: React.ReactNode;
  status: WizardItemStatus;
};

const itemBackgroundClassRecord: Record<WizardItemStatus, string> = {
  completed: 'bg-background-secondary-success-default',
  current: 'bg-background-primary-default',
  pending: 'bg-background-primary-disabled',
};

export const WizardItem = ({
  title,
  index,
  content,
  status,
}: WizardItemProps) => {
  const itemBackgroundClass = itemBackgroundClassRecord[status];

  return (
    <div
      key={index}
      className={`border-border-default rounded-12 border-1 border-solid ${itemBackgroundClass}`}
    >
      <WizardHeader title={title} index={index} status={status} />
      <AnimateHeight height={status === 'current' ? 'auto' : 0} duration={200}>
        <div className="separator" />
        <div className="m-16">{content}</div>
      </AnimateHeight>
    </div>
  );
};
